var map = {
	"./saffronfiles/assets/frameworks/we.js": "0b52",
	"./saffronfiles/assets/frameworks/we/saffronAdapter.js": "dc9c",
	"./saffronfiles/assets/frameworks/we/we.js": "bbfe",
	"./saffronfiles/config/modules/locale.js": "3bfd",
	"./saffronfiles/config/modules/router.js": "a355",
	"./saffronfiles/config/modules/style.js": "78b0",
	"./saffronfiles/config/modules/user.js": "20bb",
	"./saffronfiles/config/root.js": "4f19",
	"./saffronfiles/extensions/validation/validatorFactories/availableOnRemote.js": "e9c9",
	"./saffronfiles/extensions/validation/validators/anyI18nPhoneNumber.js": "3bed",
	"./saffronfiles/extensions/validation/validators/cleanIsraelyMobilePhoneNumber.js": "efeb",
	"./saffronfiles/extensions/validation/validators/goodPassword.js": "bdc3",
	"./saffronfiles/extensions/validation/validators/i18nPhoneNumber.js": "41f9",
	"./saffronfiles/extensions/validation/validators/i18nPhoneNumberObject.js": "4bbf",
	"./saffronfiles/extensions/validation/validators/israelyPersonalId.js": "b5fb",
	"./saffronfiles/extensions/validation/validators/urlSafeString.js": "efa2",
	"./saffronfiles/locale/en-US/locale.js": "8374",
	"./saffronfiles/locale/en-US/messages.js": "caf3",
	"./saffronfiles/locale/he-IL/locale.js": "08df",
	"./saffronfiles/locale/he-IL/messages.js": "2732",
	"./saffronfiles/pwaConfig.js": "ebc3",
	"./saffronfiles/router/middleware/redirectsLike404.js": "50b3",
	"./saffronfiles/router/middleware/requireGuest.js": "c5b6",
	"./saffronfiles/router/middleware/requireSuperAdmin.js": "19ff",
	"./saffronfiles/router/middleware/requireUser.js": "a669",
	"./saffronfiles/router/routes/core.js": "d13b",
	"./saffronfiles/router/routes/errors.js": "2258",
	"./saffronfiles/saffronfiles.js": "6f07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ff8";